import { AUTH_NOMFA } from '../constants';

export function isMFAEnabled(preferredMFA) {
  return preferredMFA !== AUTH_NOMFA;
}
